module.exports = __webpack_public_path__ + "b40a16ce583eacf2117182f54943b192.svg";